import { render, staticRenderFns } from "./AppHeader.vue?vue&type=template&id=54d45251&scoped=true&"
import script from "./AppHeader.vue?vue&type=script&lang=js&"
export * from "./AppHeader.vue?vue&type=script&lang=js&"
import style0 from "./AppHeader.vue?vue&type=style&index=0&id=54d45251&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54d45251",
  null
  
)

export default component.exports